function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9feT0", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>(parcelRequire("3voN7")).NotificationLogs);
    var $3voN7;
});
parcelRegister("3voN7", function(module, exports) {
    $parcel$export(module.exports, "NotificationLogs", ()=>$ef130062a8e57433$export$1139895a5af7252e);
    var $5uXOq = parcelRequire("5uXOq");
    var $jEoQl;
    const $ef130062a8e57433$export$1139895a5af7252e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jEoQl")).NotificationLogsPage), null);
});
parcelRegister("jEoQl", function(module, exports) {
    $parcel$export(module.exports, "NotificationLogsPage", ()=>$1b0c57a6ac72964e$export$f3b513321a19158f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $dAfqg;
    var $8pMQX;
    var $kH3pk;
    const $1b0c57a6ac72964e$export$f3b513321a19158f = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (!projectContext) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'ProjectContextNULL',
                    packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                    teamName: 'spartans'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return null;
        }
        const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);
        if (!isProjectAdmin) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'UserIsNotProjectAdmin',
                    packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                    teamName: 'spartans'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.project-not-found"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kH3pk")).NotificationLogsTabLayout), {
            projectContext: projectContext
        });
    };
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $hIKcp;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $hDzhb;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("hIKcp")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdvFP;
    var $6Ll2T;
    var $99gde;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdvFP")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("gdvFP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1e3ab6f5cd16b56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3cdTK;
    var $1VQAj;
    var $3wq9L;
    var $kOLPm;
    const $e1e3ab6f5cd16b56$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("3cdTK")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("3wq9L")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kOLPm")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $e1e3ab6f5cd16b56$var$CodeBlock.displayName = 'CodeBlock';
    var $e1e3ab6f5cd16b56$export$2e2bcd8739ae039 = $e1e3ab6f5cd16b56$var$CodeBlock;
});
parcelRegister("3cdTK", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$9354ecb135d9efb8$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $9354ecb135d9efb8$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $9354ecb135d9efb8$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1VQAj", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$1f3f8b295e4f1970$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$1f3f8b295e4f1970$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$1f3f8b295e4f1970$export$57a2d4b573afd64a);
    var $9jPr7;
    var $dW8Ue;
    const $1f3f8b295e4f1970$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $1f3f8b295e4f1970$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("9jPr7")).SPACING),
            marginRight: (0, (0, parcelRequire("9jPr7")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $1f3f8b295e4f1970$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $1f3f8b295e4f1970$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("9jPr7")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $1f3f8b295e4f1970$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("9jPr7")).SPACING}px 0` : (0, (0, parcelRequire("9jPr7")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("9jPr7")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme),
                ...$1f3f8b295e4f1970$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $1f3f8b295e4f1970$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("9jPr7")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("9jPr7")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $1f3f8b295e4f1970$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("dW8Ue")).getBaseTheme)();
        const baseStyles = $1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $1f3f8b295e4f1970$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("dW8Ue")).getBaseTheme)(),
            ...(0, (0, parcelRequire("dW8Ue")).getColorPalette)(),
            lineNumberWidth: maxLines ? $1f3f8b295e4f1970$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("9jPr7", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$16851b1001a2abd2$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$16851b1001a2abd2$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$16851b1001a2abd2$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$16851b1001a2abd2$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$16851b1001a2abd2$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$16851b1001a2abd2$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$16851b1001a2abd2$export$1758fda69688282e);
    var $bUQGL;
    const $16851b1001a2abd2$export$431ac46d758d98c8 = 12;
    const $16851b1001a2abd2$export$8e3c04032121c606 = '20px';
    const $16851b1001a2abd2$export$c8b5dc30e9f2b86e = '4px';
    const $16851b1001a2abd2$export$82ea42e772d49e5b = (0, (0, parcelRequire("bUQGL")).gridSize)();
    const $16851b1001a2abd2$export$eeeea0ff98e06fff = $16851b1001a2abd2$export$82ea42e772d49e5b * 2;
    const $16851b1001a2abd2$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $16851b1001a2abd2$export$1758fda69688282e = '--ds--code--bg-color';
    const $16851b1001a2abd2$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("dW8Ue", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$c352b5d6d7e52441$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$c352b5d6d7e52441$export$fe2a6478976e8b17);
    var $8QpSo;
    var $5w2JH;
    const $c352b5d6d7e52441$var$T800 = '#067384';
    const $c352b5d6d7e52441$var$Y1100 = '#7A5D1A';
    const $c352b5d6d7e52441$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("5w2JH")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`
        });
    const $c352b5d6d7e52441$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$72ba03e317f3d228$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`
        };
    });
    const $c352b5d6d7e52441$var$getTheme = ()=>({
            ...$c352b5d6d7e52441$export$4464aa303b3e4fda(),
            ...$c352b5d6d7e52441$export$fe2a6478976e8b17()
        });
    var $c352b5d6d7e52441$export$2e2bcd8739ae039 = $c352b5d6d7e52441$var$getTheme;
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("3wq9L", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$41e362fed9e5618b$export$f38728011c178796);
    var $8QpSo;
    var $5lUaL;
    const $41e362fed9e5618b$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("5lUaL")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("5lUaL", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$91fe7c840a716685$export$7c77c3a9bb93870d);
    const $91fe7c840a716685$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("kOLPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a42fbdf1f5ea3ed9$export$2e2bcd8739ae039);
    var $aVBRo;
    var $a42fbdf1f5ea3ed9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("aVBRo")).default);
});
parcelRegister("aVBRo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9ccff03a95a648$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTRwa;
    const $5f9ccff03a95a648$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("bTRwa")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $5f9ccff03a95a648$var$asyncGenerator = $5f9ccff03a95a648$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $5f9ccff03a95a648$export$2e2bcd8739ae039 = $5f9ccff03a95a648$var$asyncGenerator;
});
parcelRegister("bTRwa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714e39a7d165750f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bQkeD;
    var $bAA7E;
    const $714e39a7d165750f$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("bQkeD")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("bAA7E")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $714e39a7d165750f$export$2e2bcd8739ae039 = $714e39a7d165750f$var$Highlight;
});
parcelRegister("bQkeD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300f970a4217b631$export$2e2bcd8739ae039);
    var $h1mgC;
    var $7cd5I;
    var $756jv;
    var $g0987;
    const $300f970a4217b631$var$newLineRegex = /\n/g;
    function $300f970a4217b631$var$getNewLines(str) {
        return str.match($300f970a4217b631$var$newLineRegex);
    }
    function $300f970a4217b631$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g0987")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("h1mgC")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("756jv")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $300f970a4217b631$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("7cd5I")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("7cd5I")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("h1mgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e802874db56687b3$export$2e2bcd8739ae039);
    var $7cd5I;
    var $9T5KR;
    function $e802874db56687b3$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("7cd5I")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("9T5KR")).default)(lineNumber));
                return children;
            }
        };
    }
    var $e802874db56687b3$export$2e2bcd8739ae039 = $e802874db56687b3$var$createLineGenerator;
});
parcelRegister("7cd5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb90ce175080ebd7$export$2e2bcd8739ae039);
    var $9T5KR;
    function $fb90ce175080ebd7$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("9T5KR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16511336cb833d65$export$2e2bcd8739ae039);
    function $16511336cb833d65$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("756jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3722626977573637$export$2e2bcd8739ae039);
    var $7cd5I;
    function $3722626977573637$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("7cd5I")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $3722626977573637$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g0987", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$043f48aa29101879$export$2e2bcd8739ae039);
    function $043f48aa29101879$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("bAA7E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbb5a6617decb03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCYD;
    function $ffbb5a6617decb03$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("laCYD")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("laCYD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b56eeb7e6ac46855$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47G8n;
    var $dE7lx;
    var $4CTxJ;
    function $b56eeb7e6ac46855$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $b56eeb7e6ac46855$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("dE7lx")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47G8n")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("4CTxJ")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $b56eeb7e6ac46855$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("47G8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8606b73bc0e8d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $barbM;
    function $6c8606b73bc0e8d9$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            tag: $6c8606b73bc0e8d9$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $6c8606b73bc0e8d9$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("barbM", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$c9e1f2aa239b72a9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $AHUyh;
    const $c9e1f2aa239b72a9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $c9e1f2aa239b72a9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c9e1f2aa239b72a9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("dE7lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511185a3065642e8$export$2e2bcd8739ae039);
    const $511185a3065642e8$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $511185a3065642e8$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($511185a3065642e8$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("4CTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfcf1fd1989f08a6$export$2e2bcd8739ae039);
    var $laCYD;
    function $cfcf1fd1989f08a6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("laCYD")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UU68;
    var $iozM6;
    var $6Ll2T;
    var $99gde;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iozM6"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UU68")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("iozM6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d646380862d200fa$var$_react = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d646380862d200fa$var$_copy = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("4BWWV")));
    var $d646380862d200fa$var$_copy2 = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("gu5qi")));
    function $d646380862d200fa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d646380862d200fa$var$CopyIcon = (props)=>$d646380862d200fa$var$_react.default.createElement($d646380862d200fa$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $d646380862d200fa$var$_copy2.default
        }, props));
    $d646380862d200fa$var$CopyIcon.Name = 'CopyIconMigration';
    var $d646380862d200fa$var$_default = module.exports.default = $d646380862d200fa$var$CopyIcon;
});
parcelRegister("4BWWV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35b85845832ae75f$var$_react = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35b85845832ae75f$var$_UNSAFE_baseNew = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $35b85845832ae75f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35b85845832ae75f$var$CopyIcon = (props)=>$35b85845832ae75f$var$_react.default.createElement($35b85845832ae75f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $35b85845832ae75f$var$CopyIcon.displayName = 'CopyIcon';
    var $35b85845832ae75f$var$_default = module.exports.default = $35b85845832ae75f$var$CopyIcon;
});
parcelRegister("gu5qi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c003a79a3c70e52e$var$_react = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c003a79a3c70e52e$var$_copy = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("4BWWV")));
    function $c003a79a3c70e52e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c003a79a3c70e52e$var$CopyIcon = (props)=>$c003a79a3c70e52e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $c003a79a3c70e52e$var$_copy.default
        }));
    $c003a79a3c70e52e$var$CopyIcon.displayName = 'CopyIcon';
    var $c003a79a3c70e52e$var$_default = module.exports.default = $c003a79a3c70e52e$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $loZC0;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("kH3pk", function(module, exports) {
    $parcel$export(module.exports, "NotificationLogsTabLayout", ()=>$035b2a23228d11ed$export$8c09fdd1a5e9a6e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $l8dz7;
    var $2r4US;
    var $6Ll2T;
    var $99gde;
    var $cS37j;
    var $39xOx;
    var $jcw0u;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $bfjnH;
    var $h6N5n;
    var $jrqHH;
    var $jNffj;
    var $1Cifx;
    const $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs = (projectContext, breadcrumbRoot)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2r4US")).default), {
            onExpand: (0, ($parcel$interopDefault($8Rkzz)))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8dz7")).default), {
            text: breadcrumbRoot,
            href: "/jira/projects"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8dz7")).default), {
            text: `${projectContext?.projectName}`,
            href: `/browse/${projectContext?.projectKey}`
        }));
    const $035b2a23228d11ed$export$8c09fdd1a5e9a6e3 = ({ projectContext: projectContext })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const breadcrumbRoot = formatMessage((0, (0, parcelRequire("jrqHH")).messages).projects);
        const breadcrumbs = $035b2a23228d11ed$var$GetNotificationLogsBreadcrumbs(projectContext, breadcrumbRoot);
        const outgoingMailConfigData = (0, (0, parcelRequire("bfjnH")).useOutgoingMailConfig)();
        const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData;
        if (error) (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'ErrorFetchingOutgoingMailConfigDataInTabsLayout',
                packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                teamName: 'spartans'
            },
            error: new Error(error),
            sendToPrivacyUnsafeSplunk: true
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "CustomerNotificationLogsInTabsLayout",
            packageName: "jiraSpaAppsServicedeskNotificationLogs",
            teamName: "spartans"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "customerNotificationLogs",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $035b2a23228d11ed$var$notificationAppStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            breadcrumbs: breadcrumbs
        }, formatMessage((0, (0, parcelRequire("jrqHH")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNffj")).NotificationAppSubHeader), null), outgoingMailConfig !== null && !error && !loading && !outgoingMailConfig?.enabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout OutGoingMailDisabledText"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h6N5n")).EnableOutgoingMailInfo), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Cifx")).NotificationTabs), {
            projectContext: projectContext,
            outgoingMailConfigData: outgoingMailConfigData
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null)));
    };
    const $035b2a23228d11ed$var$notificationAppStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.500',
        marginRight: 'space.500'
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $95hAT;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("95hAT")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("95hAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$034db3cc90f9772f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6fW4E;
    const $034db3cc90f9772f$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fW4E")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $034db3cc90f9772f$export$2e2bcd8739ae039 = $034db3cc90f9772f$var$PageHeader;
});
parcelRegister("6fW4E", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$3eb2c0b3fddef147$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$3eb2c0b3fddef147$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$3eb2c0b3fddef147$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$3eb2c0b3fddef147$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$3eb2c0b3fddef147$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$3eb2c0b3fddef147$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $99gde;
    function $3eb2c0b3fddef147$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3eb2c0b3fddef147$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $3eb2c0b3fddef147$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $3eb2c0b3fddef147$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $3eb2c0b3fddef147$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $3eb2c0b3fddef147$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $3eb2c0b3fddef147$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $3eb2c0b3fddef147$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $3eb2c0b3fddef147$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $3eb2c0b3fddef147$var$bottomBarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $3eb2c0b3fddef147$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$outerStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $3eb2c0b3fddef147$var$titleStyles,
                truncateTitle && $3eb2c0b3fddef147$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $3eb2c0b3fddef147$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleWrapperStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $3eb2c0b3fddef147$var$titleContainerStyles,
                truncateTitle && $3eb2c0b3fddef147$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $3eb2c0b3fddef147$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3eb2c0b3fddef147$var$actionStyles
        }, children);
    };
    const $3eb2c0b3fddef147$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $3eb2c0b3fddef147$var$bottomBarStyles
        }, children);
    };
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("bfjnH", function(module, exports) {
    $parcel$export(module.exports, "useOutgoingMailConfig", ()=>$1eb57df3368ecafc$export$a0d5dcab564be259);
    var $5uXOq = parcelRequire("5uXOq");
    const $1eb57df3368ecafc$export$a0d5dcab564be259 = ()=>{
        const [outgoingMailConfig, setOutgoingMailConfig] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            const fetchOutgoingMailConfig = async ()=>{
                try {
                    setLoading(true);
                    const response = await fetch('/rest/jira-mail-plugin/1.0/outgoingMail/config');
                    if (!response.ok) throw new Error('Failed to fetch outgoingMailConfig');
                    const data = await response.json();
                    setOutgoingMailConfig(data);
                } catch (e) {
                    setError(e.message);
                } finally{
                    setLoading(false);
                }
            };
            fetchOutgoingMailConfig();
        }, []);
        return {
            outgoingMailConfig: outgoingMailConfig,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("h6N5n", function(module, exports) {
    $parcel$export(module.exports, "EnableOutgoingMailInfo", ()=>$50f0893185fbc96c$export$c75e44dac0fdc638);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6UxUy;
    var $8Q4sF;
    var $koVbs;
    var $dcwaU;
    const $50f0893185fbc96c$var$Bold = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, children);
    const $50f0893185fbc96c$export$c75e44dac0fdc638 = ()=>{
        const siteUrl = window.location.hostname;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($50f0893185fbc96c$var$OutgoingMailErrorText, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6UxUy"))))), {
            size: "medium",
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage((0, (0, parcelRequire("dcwaU")).messages).configDisabledAndHasFailureLogs, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}',
                siteUrl: siteUrl
            }),
            componentsMapping: {
                bold: $50f0893185fbc96c$var$Bold
            }
        }));
    };
    const $50f0893185fbc96c$var$OutgoingMailErrorText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4utpp _19bvidpf _1e0c1o8l _154iidpf _kqsw1if8 _1pbyowjs _bfhkvuon _1bsb1osq _vr2wh2mm _1t1812x7 _1tnd12x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8Q4sF", function(module, exports) {
    $parcel$export(module.exports, "FormattedI18nMessage", ()=>$7c8c20575fbc9bfc$export$200d7bd7633253ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHDlh;
    var $9Byym;
    const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
        const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
        const messageParts = (0, $5uXOq.useMemo)(()=>{
            const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, (0, parcelRequire("9Byym")).getTags)(componentsMapping);
            try {
                const parts = [];
                let token = '';
                let TagComponent;
                let closeTagLookup;
                for(let i = 0; i < message.length; i += 1){
                    const letter = message[i];
                    token += letter;
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter)) {
                        const firstTagFound = (0, (0, parcelRequire("9Byym")).findTag)(token, {
                            tags: openTags
                        });
                        if (firstTagFound !== null && firstTagFound !== undefined) {
                            if (TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                            const text = token.replace(firstTagFound, '');
                            parts.push(text);
                            const tagInfo = tags[firstTagFound];
                            TagComponent = tagInfo.component;
                            closeTagLookup = tagInfo.close;
                            token = '';
                        }
                    }
                    if (closeTagLookup !== null && closeTagLookup !== undefined && (0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: [
                            closeTagLookup
                        ]
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                        const text = token.replace(closeTagLookup, '');
                        parts.push((0, ($parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                        TagComponent = undefined;
                        token = '';
                        closeTagLookup = undefined;
                    }
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: closeTags
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                    }
                }
                if (TagComponent || closeTagLookup) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                if (token.length > 0) parts.push(token);
                return parts;
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("gHDlh")).MalformedMessageError)) {
                    (0, (0, parcelRequire("gHDlh")).logMalformedMessageError)({
                        message: message,
                        packageName: packageName
                    });
                    return [
                        (0, (0, parcelRequire("gHDlh")).getMalformedMessage)({
                            message: message,
                            closeTags: closeTags,
                            openTags: openTags
                        })
                    ];
                }
                throw e;
            }
        }, [
            message,
            packageName,
            componentsMapping
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: index
            }, item)));
    };
});
parcelRegister("gHDlh", function(module, exports) {
    $parcel$export(module.exports, "getMalformedMessage", ()=>$ecff24857c176a60$export$f085cf20ec1f69ab);
    $parcel$export(module.exports, "logMalformedMessageError", ()=>$ecff24857c176a60$export$954c3e6aad1c9429);
    $parcel$export(module.exports, "MalformedMessageError", ()=>$ecff24857c176a60$export$40d900e818b9630e);
    var $dJl1T;
    var $jcw0u;
    const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
            ...openTags,
            ...closeTags
        ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
    const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
        if (packageName !== null && packageName !== undefined) {
            const errorMessage = `Malformed message: ${message}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: packageName,
                    id: (0, $5514815b06163219$export$f3390a0e172fee41)
                },
                attributes: {
                    message: errorMessage
                }
            });
            const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, errorMessage);
        }
    };
    class $ecff24857c176a60$export$40d900e818b9630e extends Error {
        constructor(){
            super('Malformed i18n message');
        }
    }
});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';
parcelRegister("9Byym", function(module, exports) {
    $parcel$export(module.exports, "getTags", ()=>$84498158f946a67b$export$af63d7414243dad3);
    $parcel$export(module.exports, "isAnyTag", ()=>$84498158f946a67b$export$38ffa64fc639355f);
    $parcel$export(module.exports, "findTag", ()=>$84498158f946a67b$export$dfca0f74034f8657);
    $parcel$export(module.exports, "isCloseTagDelimiter", ()=>$84498158f946a67b$export$d5170904651e91b1);
    const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce((acc, [key, value])=>{
            const open = `{${key}Start}`;
            const close = `{${key}End}`;
            acc.tags[open] = {
                close: close,
                component: value
            };
            acc.openTags.push(open);
            acc.closeTags.push(close);
            return acc;
        }, {
            tags: {},
            openTags: [],
            closeTags: []
        });
    const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
    const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
    const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);
});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';
parcelRegister("dcwaU", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a40a3a906225b436$export$defe85febe8b728c);
    var $7VHMR;
    const $a40a3a906225b436$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        configDisabledAndHasFailureLogs: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.enable-outgoing-mail-info.config-disabled-and-has-failure-logs",
            "defaultMessage": "We couldn\u2019t refresh data because your Jira admin has disabled {boldStart}Outgoing Mail{boldEnd} for {siteUrl}."
        }
    });
});
parcelRegister("jrqHH", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d6fefbde36dd395e$export$defe85febe8b728c);
    var $7VHMR;
    const $d6fefbde36dd395e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.title",
            "defaultMessage": "Customer notification logs"
        },
        projects: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.projects",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("jNffj", function(module, exports) {
    $parcel$export(module.exports, "NotificationAppSubHeader", ()=>$6620b65b00a8c86d$export$8f6ed0d18980040c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $jZrSh;
    var $ck7yD;
    const $6620b65b00a8c86d$export$8f6ed0d18980040c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const articleId = '3VlB3YNCvdJ8c8zzo50d85';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onLearnMoreLinkClicked = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'learnMoreAboutCustomerNotificationLogsLink',
                action: 'clicked'
            }), 'learnMoreAboutCustomerNotificationLogs'), [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6620b65b00a8c86d$var$SubHeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.span"
        }, formatMessage((0, (0, parcelRequire("ck7yD")).messages).knowMoreInfoText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZrSh")).InProductHelpLink), {
            href: "",
            inProductHelpArticleId: articleId,
            learnMoreText: formatMessage((0, (0, parcelRequire("ck7yD")).messages).learnMoreText),
            onClick: onLearnMoreLinkClicked
        })));
    };
    const $6620b65b00a8c86d$var$SubHeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyrpxbi _1kdcu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jZrSh", function(module, exports) {
    $parcel$export(module.exports, "InProductHelpLink", ()=>$32955e92f3319f63$export$4fe0f115bd124cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jRBku;
    var $6Ll2T;
    var $99gde;
    var $8oe80;
    var $co1wz;
    var $4R6GH;
    var $5Zxxp;
    const $32955e92f3319f63$export$4fe0f115bd124cae = ({ href: href, inProductHelpArticleId: inProductHelpArticleId, learnMoreText: learnMoreText, onClick: onClick = (0, ($parcel$interopDefault($8Rkzz))) })=>{
        const learnMoreLink = (0, ($parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkWithAnalytics, {
            target: "_blank",
            rel: "noopener noreferrer",
            href: href,
            onClick: onClick
        }, learnMoreText);
        if (inProductHelpArticleId === undefined && !(0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return learnMoreLink;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32955e92f3319f63$var$LinkStyledHelpPanelButton, {
            testId: "servicedesk-common.components.in-product-help-link.link-styled-help-panel-button",
            fallbackComponent: learnMoreLink,
            articleId: inProductHelpArticleId,
            onClick: onClick,
            appearance: "link",
            spacing: "none",
            href: href
        }, (0, (0, parcelRequire("co1wz")).ff)('itsm-agni-25q1-a11y-fixes-_skehn') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $32955e92f3319f63$var$linkTextContainerstyles
        }, learnMoreText) : learnMoreText);
    };
    const $32955e92f3319f63$var$linkTextContainerstyles = (0, (0, parcelRequire("99gde")).xcss)({
        whiteSpace: 'normal'
    });
    const $32955e92f3319f63$var$LinkStyledHelpPanelButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5Zxxp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hms8stv _ajmmnqa1 _1r5p1kw7",
                __cmplp.className
            ])
        });
    });
    const $32955e92f3319f63$var$LinkWithAnalytics = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("jRBku")).default));
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $4Sniv;
    var $jRBku;
    var $jpY8v;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("4Sniv")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("4Sniv")).ARTICLE_TYPE)[type]
                }
            });
        };
        return !(0, (0, parcelRequire("jpY8v")).isIE11)() ? handleOnClick : undefined;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle?.(articleId, (0, (0, parcelRequire("4Sniv")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRBku")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
        return onOpenInProductHelpArticle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fallbackComponent);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("ck7yD", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7327e8745c0e5367$export$defe85febe8b728c);
    var $7VHMR;
    const $7327e8745c0e5367$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        knowMoreInfoText: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.know-more-info-text",
            "defaultMessage": "View undelivered email notifications for the last 21 days. "
        },
        learnMoreText: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-app-sub-header.learn-more-text",
            "defaultMessage": "Read more about customer notification logs. "
        }
    });
});
parcelRegister("1Cifx", function(module, exports) {
    $parcel$export(module.exports, "NotificationTabs", ()=>$4639157a6fdfd4fc$export$5dd40b7e2c20a9df);
    var $jJzIg;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $b3FEg;
    var $7qwb2;
    var $iGo0C;
    var $eotjV;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $koeKL;
    var $3OoGN;
    var $4W8YQ;
    const $4639157a6fdfd4fc$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$var$PanelWrapper, {
            "data-testid": testId
        }, children);
    const $4639157a6fdfd4fc$export$2b91517d6d5b4365 = (0, (0, parcelRequire("jJzIg")).default);
    const $4639157a6fdfd4fc$export$5dd40b7e2c20a9df = ({ projectContext: projectContext, outgoingMailConfigData: outgoingMailConfigData })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const tabTitles = [
            'customerInvite',
            'issueFailure'
        ];
        const [selectedTab, setSelectedTab] = (0, $5uXOq.useState)('CUSTOMER_INVITE');
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = projectContext?.projectId;
        const projectKey = projectContext?.projectKey;
        const fetchKey = (0, $5uXOq.useMemo)(()=>selectedTab, [
            selectedTab
        ]);
        const emailData = (0, $8Uumt.useLazyLoadQuery)($4639157a6fdfd4fc$export$2b91517d6d5b4365, {
            cloudId: cloudId,
            projectId: projectId,
            notificationType: selectedTab === 'CUSTOMER_INVITE' ? null : 'CUSTOMER_NOTIFICATION.ISSUE',
            notificationActionType: selectedTab === 'CUSTOMER_INVITE' ? 'CUSTOMER_INVITE' : null
        }, {
            fetchKey: fetchKey,
            fetchPolicy: 'network-only'
        });
        const handleTabChange = (index)=>{
            if (index === 0) {
                const analyticsEventForCustomerInvite = createAnalyticsEvent({
                    actionSubject: 'customerInviteNotificationTabs',
                    action: 'clicked'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEventForCustomerInvite);
                setSelectedTab('CUSTOMER_INVITE');
            }
            if (index === 1) {
                const analyticsEventForIssueNotification = createAnalyticsEvent({
                    actionSubject: 'issueNotificationNotificationTabs',
                    action: 'clicked'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEventForIssueNotification);
                setSelectedTab('ISSUE_NOTIFICATION');
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b3FEg")).default), {
            onChange: handleTabChange,
            id: "default"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGo0C")).default), null, tabTitles.map((title, index)=>{
            if (title === 'customerInvite') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qwb2")).default), {
                key: index,
                testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-1"
            }, formatMessage((0, (0, parcelRequire("3OoGN")).messages).customerInvite), ' ');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qwb2")).default), {
                key: index,
                testId: "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.tab-2"
            }, formatMessage((0, (0, parcelRequire("3OoGN")).messages).issueFailure));
        })), tabTitles.map((_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eotjV")).default), {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($4639157a6fdfd4fc$export$2ddb90ad54e5f587, {
                testId: `spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.panel-${index + 1}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4W8YQ")).NotificationLogsTable), {
                emailData: emailData,
                projectKey: projectKey,
                outgoingMailConfigData: outgoingMailConfigData,
                selectedTab: selectedTab
            })))));
    };
    const $4639157a6fdfd4fc$var$PanelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jJzIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4efbb2d9b0f0d09$export$2e2bcd8739ae039);
    const $b4efbb2d9b0f0d09$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationActionType"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "notificationType"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v5 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 20
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3
                ],
                "kind": "Fragment",
                "name": "notificationTabsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v3,
                    v2,
                    v1
                ],
                "kind": "Operation",
                "name": "notificationTabsQuery",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "AquaOutgoingEmailLogsQueryApi",
                        "kind": "LinkedField",
                        "name": "aquaOutgoingEmailLogs",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "notificationActionType",
                                        "variableName": "notificationActionType"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "notificationType",
                                        "variableName": "notificationType"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectId",
                                        "variableName": "projectId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "GetNotificationLogs",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": v5,
                                                "concreteType": "AquaOutgoingEmailLogConnection",
                                                "kind": "LinkedField",
                                                "name": "logs",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AquaOutgoingEmailLogItem",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AquaIssueContext",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueContext",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssue",
                                                                                "kind": "LinkedField",
                                                                                "name": "issue",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "key"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "webUrl"
                                                                                    },
                                                                                    v6
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "notificationActionType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "actionTimestamp"
                                                                    },
                                                                    {
                                                                        "concreteType": "AquaNotificationDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "notificationDetails",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "errorKey"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "mailboxMessage"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "recipient",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v4,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "email"
                                                                                    }
                                                                                ],
                                                                                "type": "AtlassianAccountUser"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ],
                                                                                "type": "CustomerUser"
                                                                            },
                                                                            v6
                                                                        ]
                                                                    },
                                                                    v4
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasPreviousPage"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "logs(first:20)"
                                            },
                                            {
                                                "args": v5,
                                                "handle": "connection",
                                                "key": "aquaOutgoingEmail__logs",
                                                "kind": "LinkedHandle",
                                                "name": "logs"
                                            }
                                        ],
                                        "type": "AquaOutgoingEmailLog"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "13a31a15254e1fa836fd63fd2ceed4a4db3667506bd24eaf3ab068d59c80452f",
                "metadata": {},
                "name": "notificationTabsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $b4efbb2d9b0f0d09$var$node.hash = "6f7dc50ebd258f4d9825a9fe7ca9f93f";
    var $b4efbb2d9b0f0d09$export$2e2bcd8739ae039 = $b4efbb2d9b0f0d09$var$node;
});
parcelRegister("b3FEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$039c3b006c14c885$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $id9yO;
    var $9KXWV;
    function $039c3b006c14c885$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $039c3b006c14c885$var$baseStyles = {
        name: "7i0hsw",
        styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
    };
    const $039c3b006c14c885$var$tabsStyles = (0, (0, parcelRequire("9KXWV")).getTabsStyles)();
    const $039c3b006c14c885$var$analyticsAttributes = {
        componentName: 'tabs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $039c3b006c14c885$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>tabPanel && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("id9yO")).TabPanelContext).Provider, {
            value: {
                role: 'tabpanel',
                id: `${tabsId}-${index}-tab`,
                hidden: isSelected ? undefined : true,
                'aria-labelledby': `${tabsId}-${index}`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tabPanel);
    const $039c3b006c14c885$var$Tabs = (props)=>{
        const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
        const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
        const selected = SelectedType === undefined ? selectedState : SelectedType;
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter((child)=>Boolean(child));
        const [tabList, ...tabPanels] = childrenArray;
        const visited = (0, $5uXOq.useRef)(new Set([
            selected
        ]));
        if (!visited.current.has(selected)) visited.current.add(selected);
        const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
            if (onChangeProp) onChangeProp(index, analyticsEvent);
            setSelected(index);
        }, [
            onChangeProp
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$039c3b006c14c885$var$analyticsAttributes
        });
        const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $039c3b006c14c885$var$getTabPanelWithContext({
            tabPanel: tabPanels[selected],
            index: selected,
            isSelected: true,
            tabsId: id
        }) : Array.from(visited.current).map((tabIndex)=>$039c3b006c14c885$var$getTabPanelWithContext({
                tabPanel: tabPanels[tabIndex],
                index: tabIndex,
                isSelected: tabIndex === selected,
                tabsId: id
            }));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $039c3b006c14c885$var$baseStyles,
                $039c3b006c14c885$var$tabsStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("id9yO")).TabListContext).Provider, {
            value: {
                selected: selected,
                onChange: onChangeAnalytics,
                tabsId: id
            }
        }, tabList), (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, tabPanelsWithContext)));
    };
    var $039c3b006c14c885$export$2e2bcd8739ae039 = $039c3b006c14c885$var$Tabs;
});
parcelRegister("id9yO", function(module, exports) {
    $parcel$export(module.exports, "TabContext", ()=>$12380d0ffaa4823f$export$5a5d356ca5f10a0a);
    $parcel$export(module.exports, "TabListContext", ()=>$12380d0ffaa4823f$export$aa6907f9fd69e93b);
    $parcel$export(module.exports, "TabPanelContext", ()=>$12380d0ffaa4823f$export$2054129d247c3102);
    var $5uXOq = parcelRequire("5uXOq");
    const $12380d0ffaa4823f$export$5a5d356ca5f10a0a = (0, $5uXOq.createContext)(null);
    const $12380d0ffaa4823f$export$aa6907f9fd69e93b = (0, $5uXOq.createContext)(null);
    const $12380d0ffaa4823f$export$2054129d247c3102 = (0, $5uXOq.createContext)(null);
});
parcelRegister("9KXWV", function(module, exports) {
    $parcel$export(module.exports, "getTabsStyles", ()=>$f58f7f42c65acdaf$export$dd5afd2190fb792c);
    $parcel$export(module.exports, "getTabListStyles", ()=>$f58f7f42c65acdaf$export$42a3c683c377bcb2);
    $parcel$export(module.exports, "getTabListStylesOld", ()=>$f58f7f42c65acdaf$export$f208f8acf591dbc2);
    var $f8Sb3;
    var $lantw;
    const $f58f7f42c65acdaf$var$tabInlinePadding = "var(--ds-space-100, 8px)";
    const $f58f7f42c65acdaf$var$tabBlockPadding = "var(--ds-space-075, 6px)";
    const $f58f7f42c65acdaf$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
    const $f58f7f42c65acdaf$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
    const $f58f7f42c65acdaf$var$getTabPanelStyles = ()=>({
            flexGrow: 1,
            minHeight: '0%',
            display: 'flex'
        });
    const $f58f7f42c65acdaf$export$dd5afd2190fb792c = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tabpanel"]': $f58f7f42c65acdaf$var$getTabPanelStyles(),
            '& > [hidden]': {
                display: 'none'
            }
        });
    const $f58f7f42c65acdaf$var$tabLineStyles = {
        content: '""',
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $f58f7f42c65acdaf$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $f58f7f42c65acdaf$export$42a3c683c377bcb2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $f58f7f42c65acdaf$export$916c8b0fccbb37d2(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $f58f7f42c65acdaf$var$tabInlineMargin,
            '&::before': {
                ...$f58f7f42c65acdaf$var$tabLineStyles,
                height: "var(--ds-border-width, 1px)",
                backgroundColor: (0, (0, parcelRequire("lantw")).tabLineColors).lineColor
            }
        });
    const $f58f7f42c65acdaf$export$916c8b0fccbb37d2 = ()=>{
        const colors = (0, (0, parcelRequire("lantw")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$f58f7f42c65acdaf$var$tabBlockPadding} ${$f58f7f42c65acdaf$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStyles,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStyles,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStyles,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
    const $f58f7f42c65acdaf$var$tabLineStylesOld = {
        content: '""',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $f58f7f42c65acdaf$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $f58f7f42c65acdaf$export$f208f8acf591dbc2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $f58f7f42c65acdaf$export$442d081208938078(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $f58f7f42c65acdaf$var$tabInlineMargin,
            '&::before': {
                ...$f58f7f42c65acdaf$var$tabLineStylesOld,
                height: $f58f7f42c65acdaf$var$underlineHeight,
                backgroundColor: (0, (0, parcelRequire("lantw")).tabLineColors).lineColor
            }
        });
    const $f58f7f42c65acdaf$export$442d081208938078 = ()=>{
        const colors = (0, (0, parcelRequire("lantw")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$f58f7f42c65acdaf$var$tabBlockPadding} ${$f58f7f42c65acdaf$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStylesOld,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${$f58f7f42c65acdaf$var$underlineHeight} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStylesOld,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${$f58f7f42c65acdaf$var$underlineHeight} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$f58f7f42c65acdaf$var$tabLineStylesOld,
                    insetInlineEnd: $f58f7f42c65acdaf$var$tabInlinePadding,
                    borderBottom: `${$f58f7f42c65acdaf$var$underlineHeight} solid ${(0, (0, parcelRequire("lantw")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
});
parcelRegister("lantw", function(module, exports) {
    $parcel$export(module.exports, "tabColors", ()=>$0fcea9c0e34e39dd$export$5159a1ad8efe50bc);
    $parcel$export(module.exports, "tabLineColors", ()=>$0fcea9c0e34e39dd$export$6be6fa4649b31472);
    const $0fcea9c0e34e39dd$export$5159a1ad8efe50bc = {
        labelColor: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`,
        activeLabelColor: `var(--ds-text, ${(0, $72ba03e317f3d228$export$a6ee3d71bc067634)})`,
        hoverLabelColor: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        selectedColor: `var(--ds-text-selected, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        focusBorderColor: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)})`
    };
    const $0fcea9c0e34e39dd$export$6be6fa4649b31472 = {
        lineColor: `var(--ds-border, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: `var(--ds-border-selected, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`
    };
});
parcelRegister("7qwb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd2a4d33943a4e4f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $l4lgX;
    var $ZuPvl;
    var $eunUc;
    const $dd2a4d33943a4e4f$var$Tab = (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
        const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, (0, parcelRequire("eunUc")).useTab)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l4lgX")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1
        }, children)));
    });
    var $dd2a4d33943a4e4f$export$2e2bcd8739ae039 = $dd2a4d33943a4e4f$var$Tab;
});
parcelRegister("eunUc", function(module, exports) {
    $parcel$export(module.exports, "useTab", ()=>$5d5238cb5726ee02$export$fdf4756d5b8ef90a);
    $parcel$export(module.exports, "useTabList", ()=>$5d5238cb5726ee02$export$773e389e644c5874);
    $parcel$export(module.exports, "useTabPanel", ()=>$5d5238cb5726ee02$export$fae0121b5afe572d);
    var $5uXOq = parcelRequire("5uXOq");
    var $id9yO;
    const $5d5238cb5726ee02$export$fdf4756d5b8ef90a = ()=>{
        const tabData = (0, $5uXOq.useContext)((0, (0, parcelRequire("id9yO")).TabContext));
        if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
        return tabData;
    };
    const $5d5238cb5726ee02$export$773e389e644c5874 = ()=>{
        const tabListData = (0, $5uXOq.useContext)((0, (0, parcelRequire("id9yO")).TabListContext));
        if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
        return tabListData;
    };
    const $5d5238cb5726ee02$export$fae0121b5afe572d = ()=>{
        const tabPanelData = (0, $5uXOq.useContext)((0, (0, parcelRequire("id9yO")).TabPanelContext));
        if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
        return tabPanelData;
    };
});
parcelRegister("iGo0C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6859187085d8b9ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $eunUc;
    var $id9yO;
    var $9KXWV;
    function $6859187085d8b9ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6859187085d8b9ff$var$baseStyles = {
        name: "g0wsdz",
        styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
    };
    const $6859187085d8b9ff$var$tabListStyles = (0, (0, parcelRequire("9KXWV")).getTabListStyles)();
    const $6859187085d8b9ff$var$tabListStylesOld = (0, (0, parcelRequire("9KXWV")).getTabListStylesOld)();
    const $6859187085d8b9ff$var$TabList = ({ children: children })=>{
        const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, (0, parcelRequire("eunUc")).useTabList)();
        const ref = (0, $5uXOq.createRef)();
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
        const length = childrenArray.length;
        const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
            const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
            if (newSelectedNode) newSelectedNode.focus();
            onChange(index);
        }, [
            tabsId,
            ref,
            onChange
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (![
                'ArrowRight',
                'ArrowLeft',
                'Home',
                'End'
            ].includes(e.key)) return;
            e.preventDefault();
            const lastTabIndex = length - 1;
            if ([
                'Home',
                'End'
            ].includes(e.key)) {
                const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
                selectTabByIndex(newSelected);
                return;
            }
            const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
            const modifier = e.key === 'ArrowRight' ? 1 : -1;
            let newSelected = selectedIndex + modifier;
            if (newSelected < 0 || newSelected >= length) newSelected = newSelected < 0 ? lastTabIndex : 0;
            selectTabByIndex(newSelected);
        }, [
            length,
            selectTabByIndex
        ]);
        const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("id9yO")).TabContext).Provider, {
                value: {
                    onClick: ()=>onChange(index),
                    onKeyDown: onKeyDown,
                    'aria-setsize': length,
                    role: 'tab',
                    id: `${tabsId}-${index}`,
                    'aria-posinset': index + 1,
                    'aria-selected': isSelected,
                    'aria-controls': `${tabsId}-${index}-tab`,
                    tabIndex: isSelected ? 0 : -1
                },
                key: index
            }, tab), [
            length,
            onKeyDown,
            onChange,
            tabsId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "tablist",
            ref: ref,
            css: [
                $6859187085d8b9ff$var$baseStyles,
                (0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') ? $6859187085d8b9ff$var$tabListStyles : $6859187085d8b9ff$var$tabListStylesOld
            ]
        }, childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))));
    };
    var $6859187085d8b9ff$export$2e2bcd8739ae039 = $6859187085d8b9ff$var$TabList;
});
parcelRegister("eotjV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f928d55ceb346041$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $l4lgX;
    var $eunUc;
    const $f928d55ceb346041$var$TabPanel = ({ children: children, testId: testId })=>{
        const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, (0, parcelRequire("eunUc")).useTabPanel)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l4lgX")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            role: role,
            id: id,
            hidden: hidden,
            "aria-labelledby": ariaLabelledBy,
            tabIndex: tabIndex
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children)));
    };
    var $f928d55ceb346041$export$2e2bcd8739ae039 = $f928d55ceb346041$var$TabPanel;
});
parcelRegister("3OoGN", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b7743d2175162a1a$export$defe85febe8b728c);
    var $7VHMR;
    const $b7743d2175162a1a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        customerInvite: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.customer-invite",
            "defaultMessage": "Customer invitations"
        },
        issueFailure: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.issue-failure",
            "defaultMessage": "Request notifications"
        }
    });
});
parcelRegister("4W8YQ", function(module, exports) {
    $parcel$export(module.exports, "NotificationLogsTable", ()=>$6b7c2ece765359d1$export$12ff1d4ce191bd1e);
    var $ajbwj;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9suPc;
    var $8Uumt = parcelRequire("8Uumt");
    var $jcw0u;
    var $5oFIy;
    var $ib5lJ;
    const $6b7c2ece765359d1$var$PAZE_SIZE = 30;
    const $6b7c2ece765359d1$var$NO_ERROR = 'No Error';
    const $6b7c2ece765359d1$export$12ff1d4ce191bd1e = ({ emailData: emailData, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
        const { data: data, loadNext: loadNext } = (0, $8Uumt.usePaginationFragment)((0, (0, parcelRequire("ajbwj")).default), emailData);
        if (!data || !data.aquaOutgoingEmailLogs) {
            const validationError = new Error('Validation Error');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'LogsQueryReturnedValidationErrorInTabsLayout',
                    packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                    teamName: 'spartans'
                },
                error: validationError,
                sendToPrivacyUnsafeSplunk: true
            });
            throw validationError;
        }
        const responseType = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.__typename;
        if (responseType === 'QueryError') {
            const errorMessage = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.message;
            const queryError = new Error(errorMessage);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'LogsQueryReturnedErrorInTabsLayout',
                    packageName: 'jiraSpaAppsServicedeskNotificationLogs',
                    teamName: 'spartans'
                },
                error: queryError,
                sendToPrivacyUnsafeSplunk: true
            });
            throw queryError;
        }
        const hasMoreData = data.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.pageInfo.hasNextPage;
        const allRows = data;
        const allRowEdges = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.logs?.edges;
        const hasError = allRows.aquaOutgoingEmailLogs?.GetNotificationLogs?.identifier ? allRows.aquaOutgoingEmailLogs?.GetNotificationLogs.message : $6b7c2ece765359d1$var$NO_ERROR;
        const parentRef = (0, $5uXOq.useRef)(null);
        const getRowHeight = (0, $5uXOq.useCallback)(()=>60, []);
        const allRowsLength = allRowEdges ? allRowEdges.length : 0;
        const virtualizer = (0, (0, parcelRequire("9suPc")).useVirtualizer)({
            count: hasMoreData ? allRowsLength + 1 : allRowsLength,
            getScrollElement: ()=>parentRef.current,
            estimateSize: getRowHeight,
            overscan: 5
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!allRowEdges || !hasMoreData) return;
            const lastItem = virtualizer.getVirtualItems().at(-1);
            if (lastItem && lastItem.index >= allRowEdges.length - 1) loadNext($6b7c2ece765359d1$var$PAZE_SIZE);
        }, [
            allRowEdges,
            hasMoreData,
            loadNext,
            virtualizer.getVirtualItems()
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6b7c2ece765359d1$var$LogsTableWrapper, {
            tabIndex: 0,
            ref: parentRef
        }, hasError === $6b7c2ece765359d1$var$NO_ERROR && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout Render"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ib5lJ")).LogsTable), {
            virtualizer: virtualizer,
            allEdges: allRowEdges || [],
            projectKey: projectKey,
            outgoingMailConfigData: outgoingMailConfigData,
            selectedTab: selectedTab
        })));
    };
    const $6b7c2ece765359d1$var$LogsTableWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3in9zg _1bsb1osq _1reo1wug _18m91wug _19pkpxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ajbwj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa75551a827aac92$export$2e2bcd8739ae039);
    var $FXmIr;
    const $fa75551a827aac92$var$node = function() {
        var v0 = [
            "aquaOutgoingEmailLogs",
            "GetNotificationLogs",
            "logs"
        ], v1 = {
            "kind": "ScalarField",
            "name": "__typename"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": 20,
                    "kind": "LocalArgument",
                    "name": "count"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "cursor"
                },
                {
                    "kind": "RootArgument",
                    "name": "notificationActionType"
                },
                {
                    "kind": "RootArgument",
                    "name": "notificationType"
                },
                {
                    "kind": "RootArgument",
                    "name": "projectId"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "connection": [
                    {
                        "count": "count",
                        "cursor": "cursor",
                        "direction": "forward",
                        "path": v0
                    }
                ],
                "refetch": {
                    "connection": {
                        "forward": {
                            "count": "count",
                            "cursor": "cursor"
                        },
                        "backward": null,
                        "path": v0
                    },
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("FXmIr")).default)
                }
            },
            "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "AquaOutgoingEmailLogsQueryApi",
                    "kind": "LinkedField",
                    "name": "aquaOutgoingEmailLogs",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "notificationActionType",
                                    "variableName": "notificationActionType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "notificationType",
                                    "variableName": "notificationType"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectId",
                                    "variableName": "projectId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "GetNotificationLogs",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "logs",
                                            "concreteType": "AquaOutgoingEmailLogConnection",
                                            "kind": "LinkedField",
                                            "name": "__aquaOutgoingEmail__logs_connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "logsTableOfTabs_logEdges"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        },
                                                        {
                                                            "concreteType": "AquaOutgoingEmailLogItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v1
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "startCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasPreviousPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "AquaOutgoingEmailLog"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v1,
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        };
    }();
    $fa75551a827aac92$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
    var $fa75551a827aac92$export$2e2bcd8739ae039 = $fa75551a827aac92$var$node;
});
parcelRegister("FXmIr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f54bbd6ecd65ea56$export$2e2bcd8739ae039);
    const $f54bbd6ecd65ea56$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "notificationActionType"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "notificationType"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectId"
            }
        ], v1 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "after",
                "variableName": "cursor"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "count"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "aquaEmailLogsQuery",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "count",
                                "variableName": "count"
                            },
                            {
                                "kind": "Variable",
                                "name": "cursor",
                                "variableName": "cursor"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "aquaEmailLogsQuery",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "AquaOutgoingEmailLogsQueryApi",
                        "kind": "LinkedField",
                        "name": "aquaOutgoingEmailLogs",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "notificationActionType",
                                        "variableName": "notificationActionType"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "notificationType",
                                        "variableName": "notificationType"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "projectId",
                                        "variableName": "projectId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "GetNotificationLogs",
                                "plural": false,
                                "selections": [
                                    v1,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": v2,
                                                "concreteType": "AquaOutgoingEmailLogConnection",
                                                "kind": "LinkedField",
                                                "name": "logs",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AquaOutgoingEmailLogItem",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AquaIssueContext",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueContext",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssue",
                                                                                "kind": "LinkedField",
                                                                                "name": "issue",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "key"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "webUrl"
                                                                                    },
                                                                                    v3
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "notificationActionType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "actionTimestamp"
                                                                    },
                                                                    {
                                                                        "concreteType": "AquaNotificationDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "notificationDetails",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "errorKey"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "mailboxMessage"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "recipient",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v1,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "email"
                                                                                    }
                                                                                ],
                                                                                "type": "AtlassianAccountUser"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "name"
                                                                                    }
                                                                                ],
                                                                                "type": "CustomerUser"
                                                                            },
                                                                            v3
                                                                        ]
                                                                    },
                                                                    v1
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasPreviousPage"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "args": v2,
                                                "handle": "connection",
                                                "key": "aquaOutgoingEmail__logs",
                                                "kind": "LinkedHandle",
                                                "name": "logs"
                                            }
                                        ],
                                        "type": "AquaOutgoingEmailLog"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "42516e8cdc4d8b41051ddf86c34fff50012d3cbb140d58a0d9283f9d09cb2d94",
                "metadata": {},
                "name": "aquaEmailLogsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $f54bbd6ecd65ea56$var$node.hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";
    var $f54bbd6ecd65ea56$export$2e2bcd8739ae039 = $f54bbd6ecd65ea56$var$node;
});
parcelRegister("9suPc", function(module, exports) {
    $parcel$export(module.exports, "elementScroll", ()=>(parcelRequire("lASGB")).elementScroll);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    $parcel$export(module.exports, "observeElementOffset", ()=>(parcelRequire("lASGB")).observeElementOffset);
    $parcel$export(module.exports, "observeElementRect", ()=>(parcelRequire("lASGB")).observeElementRect);
    $parcel$export(module.exports, "observeWindowOffset", ()=>(parcelRequire("lASGB")).observeWindowOffset);
    $parcel$export(module.exports, "observeWindowRect", ()=>(parcelRequire("lASGB")).observeWindowRect);
    $parcel$export(module.exports, "Virtualizer", ()=>(parcelRequire("lASGB")).Virtualizer);
    $parcel$export(module.exports, "windowScroll", ()=>(parcelRequire("lASGB")).windowScroll);
    $parcel$export(module.exports, "useVirtualizer", ()=>$6e2ea3c4609c52d6$export$dd6d526d88b5a137);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $lASGB;
    const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
    function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
        const rerender = $5uXOq.useReducer(()=>({}), {})[1];
        const resolvedOptions = {
            ...options,
            onChange: (instance2, sync)=>{
                var _a;
                if (sync) (0, $7nsd3.flushSync)(rerender);
                else rerender();
                (_a = options.onChange) == null || _a.call(options, instance2, sync);
            }
        };
        const [instance] = $5uXOq.useState(()=>new (0, (0, parcelRequire("lASGB")).Virtualizer)(resolvedOptions));
        instance.setOptions(resolvedOptions);
        $5uXOq.useEffect(()=>{
            return instance._didMount();
        }, []);
        $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
            return instance._willUpdate();
        });
        return instance;
    }
    function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            observeElementRect: (0, parcelRequire("lASGB")).observeElementRect,
            observeElementOffset: (0, parcelRequire("lASGB")).observeElementOffset,
            scrollToFn: (0, (0, parcelRequire("lASGB")).elementScroll),
            ...options
        });
    }
    function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            getScrollElement: ()=>typeof document !== "undefined" ? window : null,
            observeElementRect: (0, (0, parcelRequire("lASGB")).observeWindowRect),
            observeElementOffset: (0, (0, parcelRequire("lASGB")).observeWindowOffset),
            scrollToFn: (0, (0, parcelRequire("lASGB")).windowScroll),
            initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
            ...options
        });
    }
});
parcelRegister("lASGB", function(module, exports) {
    $parcel$export(module.exports, "observeElementRect", ()=>$fb876145852c2505$export$5a50ff2cde8c3802);
    $parcel$export(module.exports, "observeWindowRect", ()=>$fb876145852c2505$export$e911b82c7a99311);
    $parcel$export(module.exports, "observeElementOffset", ()=>$fb876145852c2505$export$fbc040aee017375a);
    $parcel$export(module.exports, "observeWindowOffset", ()=>$fb876145852c2505$export$518998f8c5d09287);
    $parcel$export(module.exports, "windowScroll", ()=>$fb876145852c2505$export$2162c5b3eeedd27);
    $parcel$export(module.exports, "elementScroll", ()=>$fb876145852c2505$export$1cdb988e5ab69fe7);
    $parcel$export(module.exports, "Virtualizer", ()=>$fb876145852c2505$export$89be5a243e59c4b2);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    var $cDbvq;
    const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
    const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
        const start = Math.max(range.startIndex - range.overscan, 0);
        const end = Math.min(range.endIndex + range.overscan, range.count - 1);
        const arr = [];
        for(let i = start; i <= end; i++)arr.push(i);
        return arr;
    };
    const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        const handler = (rect)=>{
            const { width: width, height: height } = rect;
            cb({
                width: Math.round(width),
                height: Math.round(height)
            });
        };
        handler(element.getBoundingClientRect());
        if (!targetWindow.ResizeObserver) return ()=>{};
        const observer = new targetWindow.ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler(element.getBoundingClientRect());
        });
        observer.observe(element, {
            box: "border-box"
        });
        return ()=>{
            observer.unobserve(element);
        };
    };
    const $fb876145852c2505$var$addEventListenerOptions = {
        passive: true
    };
    const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const handler = ()=>{
            cb({
                width: element.innerWidth,
                height: element.innerHeight
            });
        };
        handler();
        element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("resize", handler);
        };
    };
    const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
    const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                const { horizontal: horizontal, isRtl: isRtl } = instance.options;
                offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
                return size;
            }
        }
        return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
    };
    const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    class $fb876145852c2505$export$89be5a243e59c4b2 {
        constructor(opts){
            this.unsubs = [];
            this.scrollElement = null;
            this.targetWindow = null;
            this.isScrolling = false;
            this.scrollToIndexTimeoutId = null;
            this.measurementsCache = [];
            this.itemSizeCache = new Map();
            this.pendingMeasuredCacheIndexes = [];
            this.scrollRect = null;
            this.scrollOffset = null;
            this.scrollDirection = null;
            this.scrollAdjustments = 0;
            this.elementsCache = new Map();
            this.observer = (()=>{
                let _ro = null;
                const get = ()=>{
                    if (_ro) return _ro;
                    if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                    return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                        entries.forEach((entry)=>{
                            this._measureElement(entry.target, entry);
                        });
                    });
                };
                return {
                    disconnect: ()=>{
                        var _a;
                        (_a = get()) == null || _a.disconnect();
                        _ro = null;
                    },
                    observe: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.observe(target, {
                            box: "border-box"
                        });
                    },
                    unobserve: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.unobserve(target);
                    }
                };
            })();
            this.range = null;
            this.setOptions = (opts2)=>{
                Object.entries(opts2).forEach(([key, value])=>{
                    if (typeof value === "undefined") delete opts2[key];
                });
                this.options = {
                    debug: false,
                    initialOffset: 0,
                    overscan: 1,
                    paddingStart: 0,
                    paddingEnd: 0,
                    scrollPaddingStart: 0,
                    scrollPaddingEnd: 0,
                    horizontal: false,
                    getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                    rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                    onChange: ()=>{},
                    measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                    initialRect: {
                        width: 0,
                        height: 0
                    },
                    scrollMargin: 0,
                    gap: 0,
                    indexAttribute: "data-index",
                    initialMeasurementsCache: [],
                    lanes: 1,
                    isScrollingResetDelay: 150,
                    enabled: true,
                    isRtl: false,
                    ...opts2
                };
            };
            this.notify = (sync)=>{
                var _a, _b;
                (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
            };
            this.maybeNotify = (0, (0, parcelRequire("cDbvq")).memo)(()=>{
                this.calculateRange();
                return [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ];
            }, (isScrolling)=>{
                this.notify(isScrolling);
            }, {
                key: false,
                debug: ()=>this.options.debug,
                initialDeps: [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ]
            });
            this.cleanup = ()=>{
                this.unsubs.filter(Boolean).forEach((d)=>d());
                this.unsubs = [];
                this.observer.disconnect();
                this.scrollElement = null;
                this.targetWindow = null;
            };
            this._didMount = ()=>{
                return ()=>{
                    this.cleanup();
                };
            };
            this._willUpdate = ()=>{
                var _a;
                const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
                if (this.scrollElement !== scrollElement) {
                    this.cleanup();
                    if (!scrollElement) {
                        this.maybeNotify();
                        return;
                    }
                    this.scrollElement = scrollElement;
                    if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                    else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                    this.elementsCache.forEach((cached)=>{
                        this.observer.observe(cached);
                    });
                    this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: void 0,
                        behavior: void 0
                    });
                    this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                        this.scrollRect = rect;
                        this.maybeNotify();
                    }));
                    this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                        this.scrollAdjustments = 0;
                        this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                        this.scrollOffset = offset;
                        this.isScrolling = isScrolling;
                        this.maybeNotify();
                    }));
                }
            };
            this.getSize = ()=>{
                if (!this.options.enabled) {
                    this.scrollRect = null;
                    return 0;
                }
                this.scrollRect = this.scrollRect ?? this.options.initialRect;
                return this.scrollRect[this.options.horizontal ? "width" : "height"];
            };
            this.getScrollOffset = ()=>{
                if (!this.options.enabled) {
                    this.scrollOffset = null;
                    return 0;
                }
                this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
                return this.scrollOffset;
            };
            this.getFurthestMeasurement = (measurements, index)=>{
                const furthestMeasurementsFound = new Map();
                const furthestMeasurements = new Map();
                for(let m = index - 1; m >= 0; m--){
                    const measurement = measurements[m];
                    if (furthestMeasurementsFound.has(measurement.lane)) continue;
                    const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                    if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                    else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                    if (furthestMeasurementsFound.size === this.options.lanes) break;
                }
                return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                    if (a.end === b.end) return a.index - b.index;
                    return a.end - b.end;
                })[0] : void 0;
            };
            this.getMeasurementOptions = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.count,
                    this.options.paddingStart,
                    this.options.scrollMargin,
                    this.options.getItemKey,
                    this.options.enabled
                ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
                this.pendingMeasuredCacheIndexes = [];
                return {
                    count: count,
                    paddingStart: paddingStart,
                    scrollMargin: scrollMargin,
                    getItemKey: getItemKey,
                    enabled: enabled
                };
            }, {
                key: false
            });
            this.getMeasurements = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurementOptions(),
                    this.itemSizeCache
                ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
                if (!enabled) {
                    this.measurementsCache = [];
                    this.itemSizeCache.clear();
                    return [];
                }
                if (this.measurementsCache.length === 0) {
                    this.measurementsCache = this.options.initialMeasurementsCache;
                    this.measurementsCache.forEach((item)=>{
                        this.itemSizeCache.set(item.key, item.size);
                    });
                }
                const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
                this.pendingMeasuredCacheIndexes = [];
                const measurements = this.measurementsCache.slice(0, min);
                for(let i = min; i < count; i++){
                    const key = getItemKey(i);
                    const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                    const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                    const measuredSize = itemSizeCache.get(key);
                    const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                    const end = start + size;
                    const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                    measurements[i] = {
                        index: i,
                        start: start,
                        size: size,
                        end: end,
                        key: key,
                        lane: lane
                    };
                }
                this.measurementsCache = measurements;
                return measurements;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.calculateRange = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurements(),
                    this.getSize(),
                    this.getScrollOffset()
                ], (measurements, outerSize, scrollOffset)=>{
                return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                    measurements: measurements,
                    outerSize: outerSize,
                    scrollOffset: scrollOffset
                }) : null;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getIndexes = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.rangeExtractor,
                    this.calculateRange(),
                    this.options.overscan,
                    this.options.count
                ], (rangeExtractor, range, overscan, count)=>{
                return range === null ? [] : rangeExtractor({
                    startIndex: range.startIndex,
                    endIndex: range.endIndex,
                    overscan: overscan,
                    count: count
                });
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.indexFromElement = (node)=>{
                const attributeName = this.options.indexAttribute;
                const indexStr = node.getAttribute(attributeName);
                if (!indexStr) {
                    console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                    return -1;
                }
                return parseInt(indexStr, 10);
            };
            this._measureElement = (node, entry)=>{
                const index = this.indexFromElement(node);
                const item = this.measurementsCache[index];
                if (!item) return;
                const key = item.key;
                const prevNode = this.elementsCache.get(key);
                if (prevNode !== node) {
                    if (prevNode) this.observer.unobserve(prevNode);
                    this.observer.observe(node);
                    this.elementsCache.set(key, node);
                }
                if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
            };
            this.resizeItem = (index, size)=>{
                const item = this.measurementsCache[index];
                if (!item) return;
                const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
                const delta = size - itemSize;
                if (delta !== 0) {
                    if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: this.scrollAdjustments += delta,
                        behavior: void 0
                    });
                    this.pendingMeasuredCacheIndexes.push(item.index);
                    this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                    this.notify(false);
                }
            };
            this.measureElement = (node)=>{
                if (!node) {
                    this.elementsCache.forEach((cached, key)=>{
                        if (!cached.isConnected) {
                            this.observer.unobserve(cached);
                            this.elementsCache.delete(key);
                        }
                    });
                    return;
                }
                this._measureElement(node, void 0);
            };
            this.getVirtualItems = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getIndexes(),
                    this.getMeasurements()
                ], (indexes, measurements)=>{
                const virtualItems = [];
                for(let k = 0, len = indexes.length; k < len; k++){
                    const i = indexes[k];
                    const measurement = measurements[i];
                    virtualItems.push(measurement);
                }
                return virtualItems;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getVirtualItemForOffset = (offset)=>{
                const measurements = this.getMeasurements();
                if (measurements.length === 0) return void 0;
                return (0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[index]).start, offset)]);
            };
            this.getOffsetForAlignment = (toOffset, align)=>{
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (toOffset <= scrollOffset) align = "start";
                    else if (toOffset >= scrollOffset + size) align = "end";
                    else align = "start";
                }
                if (align === "start") toOffset;
                else if (align === "end") toOffset = toOffset - size;
                else if (align === "center") toOffset = toOffset - size / 2;
                const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
                const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
                const maxOffset = scrollSize - size;
                return Math.max(Math.min(maxOffset, toOffset), 0);
            };
            this.getOffsetForIndex = (index, align = "auto")=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                const item = this.measurementsCache[index];
                if (!item) return void 0;
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                    else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                    else return [
                        scrollOffset,
                        align
                    ];
                }
                const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
                return [
                    this.getOffsetForAlignment(toOffset, align),
                    align
                ];
            };
            this.isDynamicMode = ()=>this.elementsCache.size > 0;
            this.cancelScrollToIndex = ()=>{
                if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                    this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                    this.scrollToIndexTimeoutId = null;
                }
            };
            this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
                if (!offsetAndAlign) return;
                const [offset, align] = offsetAndAlign;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                    this.scrollToIndexTimeoutId = null;
                    const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                    if (elementInDOM) {
                        const [latestOffset] = (0, (0, parcelRequire("cDbvq")).notUndefined)(this.getOffsetForIndex(index, align));
                        if (!(0, (0, parcelRequire("cDbvq")).approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                            align: align,
                            behavior: behavior
                        });
                    } else this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                });
            };
            this.scrollBy = (delta, { behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getScrollOffset() + delta, {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.getTotalSize = ()=>{
                var _a;
                const measurements = this.getMeasurements();
                let end;
                if (measurements.length === 0) end = this.options.paddingStart;
                else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
                return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
            };
            this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
                this.options.scrollToFn(offset, {
                    behavior: behavior,
                    adjustments: adjustments
                }, this);
            };
            this.measure = ()=>{
                this.itemSizeCache = new Map();
                this.notify(false);
            };
            this.setOptions(opts);
        }
    }
    const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
        while(low <= high){
            const middle = (low + high) / 2 | 0;
            const currentValue = getCurrentValue(middle);
            if (currentValue < value) low = middle + 1;
            else if (currentValue > value) high = middle - 1;
            else return middle;
        }
        if (low > 0) return low - 1;
        else return 0;
    };
    function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
        const count = measurements.length - 1;
        const getOffset = (index)=>measurements[index].start;
        const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
        let endIndex = startIndex;
        while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    }
});
parcelRegister("cDbvq", function(module, exports) {
    $parcel$export(module.exports, "memo", ()=>$93220d646a94e11c$export$7c73462e0d25e514);
    $parcel$export(module.exports, "notUndefined", ()=>$93220d646a94e11c$export$9a1adf421b69c6a);
    $parcel$export(module.exports, "approxEqual", ()=>$93220d646a94e11c$export$8a4f1dcc58a69dbd);
    $parcel$export(module.exports, "debounce", ()=>$93220d646a94e11c$export$61fc7d43ac8f84b0);
    function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
        let deps = opts.initialDeps ?? [];
        let result;
        return ()=>{
            var _a, _b, _c, _d;
            let depTime;
            if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
            const newDeps = getDeps();
            const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
            if (!depsChanged) return result;
            deps = newDeps;
            let resultTime;
            if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
            result = fn(...newDeps);
            if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
            (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
            return result;
        };
    }
    function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
        if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
        else return value;
    }
    const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
    const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
        let timeoutId;
        return function(...args) {
            targetWindow.clearTimeout(timeoutId);
            timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
        };
    };
});
parcelRegister("ib5lJ", function(module, exports) {
    $parcel$export(module.exports, "LogsTable", ()=>$ce633959119528e2$export$58be81f5c6860851);
    var $igkYG;
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $loZC0;
    var $2dKrm;
    var $koVbs;
    var $cYlk7;
    var $5oFIy;
    var $cauZ3;
    var $5w5Gb;
    var $kMMUQ;
    var $luOGq;
    const $ce633959119528e2$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
    const $ce633959119528e2$var$rowRenderer = (virtualRow, edgeData, formatMessage, projectKey, selectedTab, timeZone)=>{
        const virtualRowIndex = virtualRow.index;
        if (!edgeData[virtualRowIndex]) return (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
            "data-index": virtualRowIndex,
            height: virtualRow.size,
            translateY: virtualRow.start,
            key: virtualRowIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
            selectedTab: selectedTab
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
            selectedTab: selectedTab
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).loadMoreLogs)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
            selectedTab: selectedTab
        }));
        const { node: node } = edgeData[virtualRowIndex];
        const getDetailsCell = (details, tabSelected)=>{
            let errorMessageComponent;
            if (details) errorMessageComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luOGq")).ErrorMessage), {
                errorKey: details.errorKey,
                projectKey: projectKey,
                mailboxMessage: details.mailboxMessage,
                formatMessage: formatMessage,
                tabSelected: tabSelected
            });
            const TooltipComponent = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                    ...props,
                    ref: ref
                }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$LogsDetails, {
                selectedTab: selectedTab
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                position: "bottom-start",
                component: TooltipComponent,
                content: errorMessageComponent
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.span",
                    "aria-label": "tooltip",
                    ...tooltipProps
                }, errorMessageComponent)));
        };
        const getNotificationTypeCell = (notificationType)=>{
            if (!notificationType) return null;
            const notificationName = (0, (0, parcelRequire("luOGq")).getNotificationName)(notificationType, formatMessage);
            const TooltipComponent = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                    ...props,
                    ref: ref
                }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$NotificationTypeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                position: "bottom-start",
                component: TooltipComponent,
                content: notificationName
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, notificationName)));
        };
        const getCustomerNameCell = (customerName)=>{
            const TooltipComponent = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InlineDialog, {
                    ...props,
                    ref: ref
                }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$CustomerNameWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                position: "bottom-start",
                component: TooltipComponent,
                content: customerName
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, customerName)));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, edgeData.length && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableRow, {
            "data-index": virtualRowIndex,
            height: virtualRow.size,
            translateY: virtualRow.start,
            key: virtualRowIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
            selectedTab: selectedTab
        }, (0, (0, parcelRequire("luOGq")).getLogDateTime)(node?.actionTimestamp, timeZone)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmall, {
            selectedTab: selectedTab
        }, getNotificationTypeCell(node?.notificationActionType)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellMedium, {
            selectedTab: selectedTab
        }, getCustomerNameCell(node?.recipient?.email || node?.recipient?.name)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellSmaller, {
            selectedTab: selectedTab
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            target: "_blank",
            href: node?.issueContext?.issue?.webUrl || ''
        }, node?.issueContext?.issue?.key)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableCellLarge, {
            selectedTab: selectedTab
        }, getDetailsCell(node?.notificationDetails, selectedTab))));
    };
    const $ce633959119528e2$export$ca3b93602b516d4a = ({ selectedTab: selectedTab, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("table", null, (0, ($parcel$interopDefault($5uXOq))).createElement("thead", null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderNotificationName)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).ticketKey)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderErrorMessage)))), children);
    };
    const $ce633959119528e2$export$84fdb000f10c6779 = ({ data: data, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const timeZone = typeof user.timeZone === 'string' ? user.timeZone : '';
        const { outgoingMailConfig: outgoingMailConfig, error: error, loading: loading } = outgoingMailConfigData;
        if (!data.length && !error && !loading && outgoingMailConfig !== null) {
            if (!outgoingMailConfig?.enabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
                eventName: "LogsTableInTabsLayout RenderOutgoingMailConfigDisabledTextAndEmptyTable"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
                selectedTab: selectedTab
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5w5Gb")).NoDataEnableOutgoingMailInfo), null)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
                eventName: "LogsTableInTabsLayout RenderEmptyTable"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$ca3b93602b516d4a, {
                selectedTab: selectedTab
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kMMUQ")).NoRecords), null)));
        }
        if (data.length) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "LogsTableInTabsLayout RenderTableWithData"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$InfiniteScrollTable, {
            totalSize: virtualizer.getTotalSize(),
            "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.infinite-scroll-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$Thead, null, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderDateTime)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmall, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderNotificationName)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellMedium, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderCustomerEmail)), selectedTab === $ce633959119528e2$var$issueFailuresTab && (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellSmaller, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).ticketKey)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableHeaderCellLarge, {
            selectedTab: selectedTab
        }, formatMessage((0, (0, parcelRequire("cauZ3")).messages).tableHeaderErrorMessage)))), (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$var$TableBody, {
            "data-testid": "spa-apps-servicedesk-notification-logs.ui.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-body"
        }, virtualizer.getVirtualItems().map((virtualRow)=>$ce633959119528e2$var$rowRenderer(virtualRow, data, formatMessage, projectKey, selectedTab, timeZone)))));
        return null;
    };
    const $ce633959119528e2$export$58be81f5c6860851 = ({ allEdges: allEdges, virtualizer: virtualizer, projectKey: projectKey, outgoingMailConfigData: outgoingMailConfigData, selectedTab: selectedTab })=>{
        const LogsDataFragment = (0, (0, parcelRequire("igkYG")).default);
        const data = (0, $8Uumt.useFragment)(LogsDataFragment, allEdges);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ce633959119528e2$export$84fdb000f10c6779, {
            data: data,
            virtualizer: virtualizer,
            projectKey: projectKey,
            outgoingMailConfigData: outgoingMailConfigData,
            selectedTab: selectedTab
        });
    };
    const $ce633959119528e2$var$issueFailureTab = 'ISSUE_NOTIFICATION';
    const $ce633959119528e2$var$LogsDetails = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb1ogm" : "_1bsbcv93",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$CustomerNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogy",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$NotificationTypeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1ogy",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableCellSmaller = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableCellSmall = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableCellMedium = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableCellLarge = (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$Thead = (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_154iidpf _kqsw1if8 _1pbyb4wl _bfhkvuon _syaz1aqp",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableHeaderCellSmaller = (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsb9by0" : "_1bsbka7h",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableHeaderCellSmall = (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbrq8m" : "_1bsbka7h",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableHeaderCellMedium = (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbka7h" : "_1bsb1x1l",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableHeaderCellLarge = (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { selectedTab: selectedTab, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o _1bah1y6m _kqsw1if8 _k48p4jg8",
                __cmplp.selectedTab === $ce633959119528e2$var$issueFailureTab ? "_1bsbxe31" : "_1bsb1ssb",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableRow = (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { translateY: translateY, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1neqek2": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.height}px`),
                "--_1eykf4m": (0, (0, parcelRequire("lD23V")).default)(`translateY(${__cmplp.translateY}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsb1osq _4t3i2nrh _t9ec1inw _19pku2gc _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$TableBody = (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1kw7",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$InfiniteScrollTable = (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { totalSize: totalSize, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_r9fzc2": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.totalSize}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1651 _1bsb1osq _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $ce633959119528e2$var$InlineDialog = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2dKrm")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7vuon _2rko1l7b _16qs1mxi _p12fnklw _vchh18uv _ca0q7vkz _u5f31tcg _n3td7vkz _19bv1tcg _1nmz1hna",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("igkYG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b27263127f0e5e4$export$2e2bcd8739ae039);
    const $4b27263127f0e5e4$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "logsTableOfTabs_logEdges",
        "selections": [
            {
                "concreteType": "AquaOutgoingEmailLogItem",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "AquaIssueContext",
                        "kind": "LinkedField",
                        "name": "issueContext",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "webUrl"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "notificationActionType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "actionTimestamp"
                    },
                    {
                        "concreteType": "AquaNotificationDetails",
                        "kind": "LinkedField",
                        "name": "notificationDetails",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "errorKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "mailboxMessage"
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "name": "recipient",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ],
                                "type": "CustomerUser"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "AquaOutgoingEmailLogItemEdge"
    };
    $4b27263127f0e5e4$var$node.hash = "1f58a219fb28a24ee938089d6601c5a2";
    var $4b27263127f0e5e4$export$2e2bcd8739ae039 = $4b27263127f0e5e4$var$node;
});
parcelRegister("cauZ3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3dc15c60c4cd538d$export$defe85febe8b728c);
    var $7VHMR;
    const $3dc15c60c4cd538d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        renderingFailed: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rendering-failed",
            "defaultMessage": "Internal error. {linkStart}Resend the invite{linkEnd} later."
        },
        requestTooLong: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-too-long",
            "defaultMessage": "Notification size is greater than 6 MB. Reduce the size of customer invite template."
        },
        emailValidationFailure: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-validation-failure",
            "defaultMessage": "Unable to validate recipient\u2019s email address. Check the format and invite again."
        },
        rfc1918LanIpRoutingFailure: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.rfc-1918-lan-ip-routing-failure",
            "defaultMessage": "Recipient\u2019s email address belongs to a private address space. Invite again using the correct email address."
        },
        suppressedMessage: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message",
            "defaultMessage": "Recipient\u2019s email address is on a suppression list. Resend invite from the {linkStart}Customers page{linkEnd}."
        },
        suppressedMessageForRequestNotifications: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.suppressed-message-for-request-notifications",
            "defaultMessage": "Recipient\u2019s email address is on a suppression list."
        },
        bounced: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.bounced",
            "defaultMessage": "Error from email provider"
        },
        emailNotificationLimitReached: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.email-notification-limit-reached",
            "defaultMessage": "Reached the email notifications limit for {siteUrl}."
        },
        defaultErrorMessage: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message",
            "defaultMessage": "An unknown error occurred. Try again later."
        },
        defaultErrorMessageForRequestNotification: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.default-error-message-for-request-notification",
            "defaultMessage": "An unknown error occurred."
        },
        tableHeaderDateTime: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-date-time",
            "defaultMessage": "Date and time"
        },
        tableHeaderNotificationName: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-notification-name",
            "defaultMessage": "Notification name"
        },
        tableHeaderCustomerEmail: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-customer-email",
            "defaultMessage": "Recipient"
        },
        tableHeaderErrorMessage: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.table-header-error-message",
            "defaultMessage": "Details"
        },
        ticketKey: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.ticket-key",
            "defaultMessage": "Issue key"
        },
        customerInvited: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-invited",
            "defaultMessage": "Customer invited"
        },
        requestCreated: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-created",
            "defaultMessage": "Request created"
        },
        publicCommentAdded: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-added",
            "defaultMessage": "Public comment added"
        },
        publicCommentEdited: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.public-comment-edited",
            "defaultMessage": "Public comment edited"
        },
        requestResolved: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-resolved",
            "defaultMessage": "Request resolved"
        },
        requestReopened: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.request-reopened",
            "defaultMessage": "Request reopened"
        },
        participantAdded: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.participant-added",
            "defaultMessage": "Participant added"
        },
        organizationAdded: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.organization-added",
            "defaultMessage": "Organization added"
        },
        approvalRequired: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.approval-required",
            "defaultMessage": "Approval required"
        },
        customerVisibleStatusChanged: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.customer-visible-status-changed",
            "defaultMessage": "Customer-visible status changed"
        },
        customNotification: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.custom-notification",
            "defaultMessage": "Custom notification"
        },
        loadMoreLogs: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.load-more-logs",
            "defaultMessage": "Loading more logs..."
        }
    });
});
parcelRegister("5w5Gb", function(module, exports) {
    $parcel$export(module.exports, "NoDataEnableOutgoingMailInfo", ()=>$9860b096251afcf0$export$31d032be89b0df83);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6UxUy;
    var $8Q4sF;
    var $2JXc1;
    var $koVbs;
    var $kiDgp;
    const $9860b096251afcf0$var$Bold = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, children);
    const $9860b096251afcf0$export$31d032be89b0df83 = ()=>{
        const siteUrl = window.location.hostname;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailInfoWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JXc1")).default), {
            height: "222",
            width: "191",
            alt: "no failure logs"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($9860b096251afcf0$var$OutgoingMailErrorText, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6UxUy"))))), {
            size: "medium",
            label: "",
            primaryColor: `var(--ds-icon-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage((0, (0, parcelRequire("kiDgp")).messages).configDisabledAndNoFailureLogs, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}',
                siteUrl: siteUrl
            }),
            componentsMapping: {
                bold: $9860b096251afcf0$var$Bold
            }
        }))));
    };
    const $9860b096251afcf0$var$OutgoingMailErrorContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3idgin",
                __cmplp.className
            ])
        });
    });
    const $9860b096251afcf0$var$OutgoingMailInfoWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8utpp _18u0idpf _y3gn1h6o _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4",
                __cmplp.className
            ])
        });
    });
    const $9860b096251afcf0$var$OutgoingMailErrorText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4utpp _19bvidpf _1e0c1o8l _vr2wh2mm _1t1812x7 _1tnd12x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2JXc1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5d3fe7c3133ec07$export$2e2bcd8739ae039);
    var $dCLgq;
    var $cid60 = parcelRequire("cid60");
    var $6y2Qu = parcelRequire("6y2Qu");
    const $c5d3fe7c3133ec07$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($6y2Qu)),
        srcDark: ($parcel$interopDefault($cid60))
    });
    var $c5d3fe7c3133ec07$export$2e2bcd8739ae039 = $c5d3fe7c3133ec07$var$Illustration;
    const $c5d3fe7c3133ec07$export$a179c88182cb9d56 = [
        0,
        0,
        191,
        222
    ];
});
parcelRegister("cid60", function(module, exports) {
    module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();
});
parcelRegister("6y2Qu", function(module, exports) {
    module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();
});
parcelRegister("kiDgp", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$c535b9b4b8efd498$export$defe85febe8b728c);
    var $7VHMR;
    const $c535b9b4b8efd498$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        configDisabledAndNoFailureLogs: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-data-enable-outgoing-mail-info.config-disabled-and-no-failure-logs",
            "defaultMessage": "No data available as {boldStart}Outgoing Mail{boldEnd} is disabled for {siteUrl}."
        }
    });
});
parcelRegister("kMMUQ", function(module, exports) {
    $parcel$export(module.exports, "NoRecords", ()=>$e514ea095591694f$export$cdb065a719ea8884);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ll2T;
    var $99gde;
    var $3a3KV;
    var $koVbs;
    var $6oCSI;
    const $e514ea095591694f$export$cdb065a719ea8884 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e514ea095591694f$var$AllGoodContent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $e514ea095591694f$var$imageContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3a3KV")).default), {
            height: "150",
            width: "139",
            alt: "no failure logs"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("h5", null, formatMessage((0, (0, parcelRequire("6oCSI")).messages).configEnabledAndNoFailureLogsMainText))));
    };
    const $e514ea095591694f$var$AllGoodContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3ibfng",
                __cmplp.className
            ])
        });
    });
    const $e514ea095591694f$var$AllGoodContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _13tb1ejb _1gtfidpf",
                __cmplp.className
            ])
        });
    });
    const $e514ea095591694f$var$imageContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        justifyContent: 'center'
    });
});
parcelRegister("3a3KV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f7e7138359f79b9$export$2e2bcd8739ae039);
    var $dCLgq;
    var $gtj36 = parcelRequire("gtj36");
    const $2f7e7138359f79b9$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($gtj36)),
        srcDark: ($parcel$interopDefault($gtj36))
    });
    var $2f7e7138359f79b9$export$2e2bcd8739ae039 = $2f7e7138359f79b9$var$Illustration;
    const $2f7e7138359f79b9$export$a179c88182cb9d56 = [
        0,
        0,
        226,
        244
    ];
});
parcelRegister("gtj36", function(module, exports) {
    module.exports = new URL("service-success.e99f1cd7.svg", import.meta.url).toString();
});
parcelRegister("6oCSI", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf7e923ae07c269c$export$defe85febe8b728c);
    var $7VHMR;
    const $bf7e923ae07c269c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        configEnabledAndNoFailureLogsMainText: {
            "id": "spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.notification-tabs.notification-table.logs-table.no-records.config-enabled-and-no-failure-logs-main-text",
            "defaultMessage": "All set! Customer notifications were delivered successfully for your project."
        }
    });
});
parcelRegister("luOGq", function(module, exports) {
    $parcel$export(module.exports, "getLogDateTime", ()=>$0ced444745e60ec9$export$fbe52a537db76a48);
    $parcel$export(module.exports, "ErrorMessage", ()=>$0ced444745e60ec9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "getNotificationName", ()=>$0ced444745e60ec9$export$dc44215dd42a02db);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMcV;
    var $2APCZ;
    var $8Q4sF;
    var $ousew;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $cauZ3;
    const $0ced444745e60ec9$var$issueFailuresTab = 'ISSUE_NOTIFICATION';
    const $0ced444745e60ec9$export$fbe52a537db76a48 = (dateString, timeZone)=>{
        if (dateString) {
            const dateObj = (0, (0, parcelRequire("7CMcV")).default)(dateString, timeZone);
            const year = dateObj.getFullYear();
            const month = dateObj.toLocaleString('en-us', {
                month: 'short'
            });
            const day = dateObj.getDate();
            const hours = dateObj.getHours();
            const minutes = dateObj.getMinutes();
            const outputDateString = `${month} ${day}, ${year} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            return outputDateString;
        }
        return dateString;
    };
    const $0ced444745e60ec9$var$FormattedErrorWithLinkButton = ({ href: href, errorMessage: errorMessage, onLinkButtonClicked: onLinkButtonClicked })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            componentsMapping: {
                link: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                        appearance: "link",
                        spacing: "none",
                        href: href,
                        target: "_blank",
                        onClick: onLinkButtonClicked
                    }, props.children)
            },
            message: formatMessage(errorMessage, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            })
        });
    };
    const $0ced444745e60ec9$var$FormattedErrorText = ({ errorMessage: errorMessage })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(errorMessage));
    };
    const $0ced444745e60ec9$export$300e9e75480e4710 = ({ mailboxMessage: mailboxMessage, formatMessage: formatMessage })=>{
        const bouncedMessage = `${formatMessage((0, (0, parcelRequire("cauZ3")).messages).bounced)}: ${mailboxMessage}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, bouncedMessage);
    };
    const $0ced444745e60ec9$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, projectKey: projectKey, mailboxMessage: mailboxMessage, formatMessage: formatMessage, tabSelected: tabSelected })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onInternalErrorResendInviteClicked = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'internalErrorResendInviteLink',
                action: 'clicked'
            }), 'internalErrorResendInvite'), [
            createAnalyticsEvent
        ]);
        const suppressedErrorGoToCustomersPageClicked = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'suppressedErrorGoToCustomersPageLink',
                action: 'clicked'
            }), 'suppressedErrorGoToCustomersPage'), [
            createAnalyticsEvent
        ]);
        switch(errorKey && errorKey.toLowerCase()){
            case 'rendering_failed':
            case 'retrieve_configuration_failed':
            case 'retryable_am_failure':
            case 'unknown_failure':
                {
                    const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                        href: href,
                        errorMessage: (0, (0, parcelRequire("cauZ3")).messages).renderingFailed,
                        onLinkButtonClicked: onInternalErrorResendInviteClicked
                    });
                }
            case 'request_too_long':
            case 'request_size_exceeded':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, (0, parcelRequire("cauZ3")).messages).requestTooLong
                });
            case 'email_validation_failure':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, (0, parcelRequire("cauZ3")).messages).emailValidationFailure
                });
            case 'rfc1918_lan_ip_routing_failure':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, (0, parcelRequire("cauZ3")).messages).rfc1918LanIpRoutingFailure
                });
            case 'suppressed':
                {
                    if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                        errorMessage: (0, (0, parcelRequire("cauZ3")).messages).suppressedMessageForRequestNotifications
                    });
                    const href = `/jira/servicedesk/projects/${projectKey}/customers`;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorWithLinkButton, {
                        href: href,
                        errorMessage: (0, (0, parcelRequire("cauZ3")).messages).suppressedMessage,
                        onLinkButtonClicked: suppressedErrorGoToCustomersPageClicked
                    });
                }
            case 'email_notification_limit_reached':
                {
                    const siteUrl = window.location.hostname;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                        values: {
                            siteUrl: siteUrl
                        },
                        ...(0, (0, parcelRequire("cauZ3")).messages).emailNotificationLimitReached
                    });
                }
            case 'bounced':
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$export$300e9e75480e4710, {
                    mailboxMessage: mailboxMessage,
                    formatMessage: formatMessage
                });
            default:
                if (tabSelected === $0ced444745e60ec9$var$issueFailuresTab) return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, (0, parcelRequire("cauZ3")).messages).defaultErrorMessageForRequestNotification
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0ced444745e60ec9$var$FormattedErrorText, {
                    errorMessage: (0, (0, parcelRequire("cauZ3")).messages).defaultErrorMessage
                });
        }
    };
    const $0ced444745e60ec9$export$dc44215dd42a02db = (notificationType, formatMessage)=>{
        switch(notificationType.toLowerCase()){
            case 'customer_invite':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).customerInvited);
            case 'request_created':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).requestCreated);
            case 'public_comment_added':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).publicCommentAdded);
            case 'public_comment_edited':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).publicCommentEdited);
            case 'request_resolved':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).requestResolved);
            case 'request_reopened':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).requestReopened);
            case 'participant_added':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).participantAdded);
            case 'organisation_added':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).organizationAdded);
            case 'approval_required':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).approvalRequired);
            case 'customer_visible_status_changed':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).customerVisibleStatusChanged);
            case 'custom_notification':
                return formatMessage((0, (0, parcelRequire("cauZ3")).messages).customNotification);
            default:
                return '';
        }
    };
});
